import { createActions, createReducer } from "reduxsauce"
import Immutable from "seamless-immutable"

/* ------------- Types and Action Creators ------------- */

const { Types, Creators } = createActions({
  navSetProp: ["key", "value"],
  logout: null
})

export const NavTypes = Types
export default Creators

/* ------------- Initial State ------------- */

export const INITIAL_STATE = Immutable({
  isDesktop: false,
  showConfirm: null,
  isMobile: false,
  isShowMenu: false,
  isShowSideBar: true,
  tabPosition: { x: 0, y: 0 },
  theme: localStorage.getItem("chargebackTheme")
    ? localStorage.getItem("chargebackTheme")
    : "light",
  // Incognito (a.k.a. Private) mode: masks sensitive metrics/PII with ∗ across the app so the
  // account can be shown on a shared screen or in a demo without revealing real numbers.
  incognito: localStorage.getItem("chargebackIncognito") === "true",
  disabledTransition: false
})

/* ------------- Selectors ------------- */
export const navSetPropRedux = (state, { key, value }) => {
  const obj = {}
  obj[key] = value

  if (key === "theme") {
    localStorage.setItem("chargebackTheme", value)
    document.body.style.backgroundColor = value === "dark" ? "#030625" : "#ffffff"
    document
      .querySelector('meta[name="theme-color"]')
      .setAttribute("content", value === "dark" ? "#030625" : "#ffffff")
  }

  if (key === "incognito") {
    localStorage.setItem("chargebackIncognito", value ? "true" : "false")
  }

  return state.merge(obj)
}

export const logout = (state) =>
  state.merge({
    ...INITIAL_STATE,
    theme: localStorage.getItem("chargebackTheme")
      ? localStorage.getItem("chargebackTheme")
      : "light",
    incognito: localStorage.getItem("chargebackIncognito") === "true"
  })

/* ------------- Hookup Reducers To Types ------------- */
export const reducer = createReducer(INITIAL_STATE, {
  [Types.NAV_SET_PROP]: navSetPropRedux,
  [Types.LOGOUT]: logout
})
